import React, { useState } from "react";
import PropTypes from "prop-types";

import { numberWithCommas } from "../utilities/utilities";

// "Page [X] of Y" where X is an input the user can type a 1-based page number into
const PageJumpLabel = ({ page, totalPages, onChange, style }) => {
	const total = Math.max(totalPages || 1, 1);
	// null while not editing so the input follows the current page
	const [draft, setDraft] = useState(null);

	const submit = () => {
		const parsed = parseInt(draft, 10);
		setDraft(null);
		if (Number.isNaN(parsed)) {
			return;
		}
		const target = Math.min(Math.max(parsed, 1), total);
		if (target !== page) {
			onChange(target);
		}
	};

	return (
		<span style={style}>
			{"Page "}
			{total === 1 ? (
				"1"
			) : (
				<input
					inputMode="numeric"
					aria-label="go to page"
					title="Type a page number and press Enter"
					value={draft ?? String(page)}
					onFocus={(e) => e.target.select()}
					onChange={(e) =>
						setDraft(e.target.value.replace(/\D/g, ""))
					}
					onBlur={submit}
					onKeyDown={(e) => {
						if (e.key === "Enter") {
							e.target.blur();
						} else if (e.key === "Escape") {
							setDraft(null);
						}
					}}
					style={{
						width: `calc(${String(total).length}ch + 14px)`,
						height: 28,
						boxSizing: "border-box",
						padding: "0 4px",
						textAlign: "center",
						font: "inherit",
						border: "1px solid rgba(0, 0, 0, 0.25)",
						borderRadius: 4,
					}}
				/>
			)}
			{` of ${numberWithCommas(total)}`}
		</span>
	);
};

PageJumpLabel.propTypes = {
	page: PropTypes.number.isRequired,
	totalPages: PropTypes.number,
	onChange: PropTypes.func.isRequired,
	style: PropTypes.object,
};

export default PageJumpLabel;
